/**
 * HomeStageTab — placeholder renderer for the Home Stage tab.
 *
 * Home stage is server-owned; the client journal does not yet read the
 * stage projection. The dispatch helper returns the empty-state copy and
 * this renderer surfaces it. When the stage projection lands on the
 * Colyseus schema (or a per-character pull endpoint), `buildHomeStageTab`
 * will populate `state.lines` with the current stage label + a quiet
 * "what comes next" line.
 */

import * as Phaser from 'phaser';
import { renderEmptyStateTab } from './emptyStateRenderer';
import type { JournalTabState } from './journalDispatch';

export function renderHomeStageTab(
  scene: Phaser.Scene,
  container: Phaser.GameObjects.Container,
  state: JournalTabState,
): void {
  renderEmptyStateTab(scene, container, state);
}
